import { useEffect, useState } from 'react';
import './StoreList.scss';
import { FetchData } from '../../utils/FetchData'
import { storeImgUrl } from "../../config";

export function StoreList () {
    const [list, setList] = useState<Array<any>>([]);
    const [token, setToken] = useState<string>();

    const fetchArticleList = () => {
        FetchData('articulos/listportada').
         then((data) => {
            setList(data.response.articulos);
            setToken(data.response.imgToken);
        }).catch((e) => console.error(e));
    }
  
    useEffect(() => {
        fetchArticleList();
    }, []);

    const callImage = (fileName: string): string => {
        return token
          ? `${storeImgUrl}?filename=${fileName}&t=${encodeURI(token)}`
          : "";
    };

    return (
        <>
        { list.length > 0 && <div className="store-list">
                <h2><a href="./tienda"><i className="fas fa-shopping-cart"></i> Tienda</a></h2>
                <ul className='store-list__list to-rows-mobile'>
                    { list.map((articulo, index) => (
                        <li key={index} className='store-list__list-item' style={{ backgroundImage: `url('${callImage(articulo.imagen)}`}}>
                            <a href={`./tienda/#/articulo/${articulo.clave}`}>
                                <h4>{articulo.titulo}</h4>     
                                <span className='store-list__price'>{articulo.precio}&euro; Comprar</span>                                               
                            </a>
                        </li>
                    ))}
                </ul>
            </div>}
        </>
    );

}